const getIsStampRequired = () => {
    const isStampRequired = localStorage.getItem("isStampRequired")
        ? JSON.parse(localStorage.getItem("isStampRequired"))
        : null;

    return isStampRequired;
};

const InitialState = {
    isStampRequired: getIsStampRequired(),
};

const IsStampRequiredReducer = (state = InitialState, action) => {
    if (action.type === "Save_isStampRequired") {
        const newState = {
            ...state,
            isStampRequired: action.payload,
        };
        localStorage.setItem("isStampRequired", JSON.stringify(action.payload));
        return newState;
    }

    else if (action.type === "Remove_User") {
        localStorage.removeItem("isStampRequired");
        const newState = {
            isStampRequired: null
        };
        return newState;
    }

    return state;
};

export default IsStampRequiredReducer;